import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { NetworkConnectionService } from './_services/monitoring/network-connection.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit, OnDestroy {
  private networkSubscription: Subscription;

  constructor(
    private networkConnectionService: NetworkConnectionService,
  ) {

  }

  ngOnInit(): void {
    this.networkSubscription = this.networkConnectionService.monitor().subscribe(values => {
      var currentDate = '[' + new Date().toISOString() + ']';

      console.log(currentDate, 'network connection:', values);
    });
  }

  ngOnDestroy(): void {
    if (this.networkSubscription) {
      this.networkSubscription.unsubscribe();
    }
  }
}
